/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { SupervisorPhotoUrlResponse } from './supervisorPhotoUrlResponse';

export type GenericApiResponseSupervisorPhotoUrlResponseData = SupervisorPhotoUrlResponse | null;
